<div>
  <h2>Download data</h2>
  <form (submit)="downloadData()" [formGroup]="downloadDataForm" autocomplete="off">
    <div class="form-container">

      <mat-form-field appearance="outline" >
        <mat-label>Years</mat-label>
        <mat-select [formControl]="yearsControl">
          <mat-option *ngFor="let year of years" [value]="year">{{year}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" >
        <mat-label>Countries</mat-label>
        <mat-select [formControl]="countriesControl" multiple>
          <mat-option *ngFor="let country of countries" [value]="country.id">{{country.name}}</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="download-button-container">
        <button [disabled]="downloadDataForm.invalid" mat-raised-button color="primary" type="submit">
          <span>Download</span>
        </button>
      </div>
    </div>
  </form>
</div>
